import {useParams} from 'react-router-dom';
import useSWRImmutable from 'swr/immutable';
import axios from 'axios';
import st from './Representative.module.scss';
import {useAppContext} from '../../../Context';

const fetcher = async (url)=> {
    return await axios.get(url)
}

export const Detail = ()=> {
    const { region } = useAppContext()
    const params = useParams()
    const { data: herb } = useSWRImmutable('/region/herb/'+params?.id, fetcher)
    const { data } = useSWRImmutable('/region/representative/'+params?.id, fetcher)

    return (
        <div className={st.wrapper}>
            <div className={st.header}>
                <div className={st.header_logo}>
                    <div className={st.header_logo_in}>
                        <img src={herb?.data?.data?.image?.path} alt=""/>
                    </div>
                </div>
                <div className={st.header_title}>
                    {region?.name}
                </div>
            </div>

            <div className={st.body}>
                {data?.data?.data.length > 0 &&
                    <div className={st.body_title}>РЕГИОНАЛЬНЫЕ ПРЕДСТАВИТЕЛИ</div>
                }
                {data?.data?.data?.map(item => (
                    <div key={item.id} className={st.block}>
                        { item.image?.path &&
                            <div className={st.body_img}>
                                <img src={item.image?.path} alt="" className={st.body_img} />
                            </div>
                        }

                        <div className={st.body_sub_title}>
                            {item.title}
                        </div>
                        <div className={st.body_text} dangerouslySetInnerHTML={{__html: item.content}} />
                    </div>
                ))}
            </div>
        </div>
    )
}
